import Loadable from 'react/components/loadable';

const ZeroBookingsPlaceholder = Loadable({
  loader: () => import('../../pages/calendar/zero_bookings_placeholder'),
});

angular.module('gym').value('ZeroBookingsPlaceholder', ZeroBookingsPlaceholder);
